import { useState, useCallback } from "react"

const useToast = () => {
    const [toast, setToast] = useState({ isVisible: false, message: "" })

    const showToast = useCallback((message) => {
        setToast({ isVisible: true, message })
    }, [])

    const hideToast = useCallback(() => {
        // 애니메이션 시작 전 상태를 업데이트
        setToast((prev) => ({ ...prev, isVisible: false }))
    }, [])

    return {
        toast,
        showToast,
        hideToast,
    }
}

export default useToast
